
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cognito_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actual_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actual_working_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionnal_needs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contract"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"experiences"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_distance_learning"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_professional_courses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_disabled_worker"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"level_studies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"professional_courses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rise_working_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_seen_conversation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promotion_users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotion_id"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":694}};
    doc.loc.source = {"body":"query userQuery ($cognitoId: String!){\n    users (where: { cognito_id: {_eq: $cognitoId } }) {\n        id,\n\n        email,\n        name,\n        first_name,\n        actual_position,\n        actual_working_time,\n        additionnal_needs,\n        avatar_id,\n        contract,\n        expectations,\n#        experience_course,\n#        experience_other,\n#        experience_seminar,\n        experiences,\n        gender,\n        has_distance_learning,\n        has_professional_courses,\n        is_disabled_worker,\n        level_studies,\n        professional_courses,\n        rise_working_time,\n        last_seen_conversation,\n\n        promotion_users {\n            promotion_id\n        }\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["userQuery"] = oneQuery(doc, "userQuery");
        
